import React from "react";
import styles from "../PreviewV3.module.css";

export default function JSASection({ sectionData, displayName, sectionNumber, targetId }) {

  return (
    <div className={styles.PreviewSectionBlock} id={targetId} style={{ scrollMarginTop: "140px" }}>
      <div className={styles.PreviewSectionHead}>
        <span className={styles.PreviewSectionNum}>{sectionNumber}</span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}></div>
    </div>
  )
}